import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { EmailSendService } from 'src/app/services/email-send.service';

@Component({
  selector: 'calsoft-inbound-emails',
  templateUrl: './inbound-emails.component.html',
  styleUrls: ['./inbound-emails.component.scss']
})
export class InboundEmailsComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() type: any = 1;

  @Input() leadId: any = 0;

  @Input() leadObject: any = 0;
  dialerShow: boolean;
  redirected: boolean;
  textAccount: string;
  fromEmail: any;
  toEmail: any;

  constructor(
    private emailSendService: EmailSendService,
    private router: Router,
    private location: Location,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  @Input() columns: ListColumn[] = []

  filterSelectObj = [];
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;


  ngOnInit(): void {

    console.log(this.leadObject);

    this.fromEmail = this.leadObject?.email;

    this.toEmail = this.leadObject.ownerEmail;

    this.columns = [

      { name: 'From Address', property: 'fromAddress', visible: true, isModelProperty: true },
      { name: 'To Address', property: 'toAddress', visible: true, isModelProperty: false },
      { name: 'Subject', property: 'subject', visible: true, isModelProperty: false },
      { name: 'Received At', property: 'receivedAt', visible: true, isModelProperty: false },
      // { name: 'Action', property: 'actions', visible: true, disabled: true },
    ] as ListColumn[];


    this.filterSelectObj = [
      {
        name: 'From Address',
        property: 'fromAddress',
        type: 'text',
        position: 'firstValue',
        options: []
      },
    ]



    if (this.fromEmail != undefined && this.toEmail != undefined
      && this.fromEmail != '' && this.toEmail != '' && this.fromEmail != null && this.toEmail != null) {
      this.getAllInboundEmails();
    } else {

      this.inboundEmailList = [];
    }


  }
  isPopupOpenTwo = false;
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];

  totalElements: number = 0;
  sortParam: any = 'id' + "," + Constant.Dsc;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  inboundEmailList: any = [];
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  spinner: boolean;
  totalLeadCount: any;
  elements: any
  pageList: any;

  pageSizeValue: any;
  sortParamInit: any = 'id' + "," + Constant.Dsc;

  getAllInboundEmails() {
    this.spinner = true;

    this.emailSendService.getAllInboundEmail(this.fromEmail, this.toEmail, this.page, this.size, this.sortParam).subscribe(
      res => {
        console.log(res);
        this.spinner = false;
        this.inboundEmailList = new MatTableDataSource();
        this.inboundEmailList = res['content'];
        this.elements = res['numberOfElements'];
        this.inboundEmailList.sort = this.sort;
        this.inboundEmailList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
      }
    )
  }

  getUpdate(event) {

    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;


    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');



    if (questionMarkIndex !== -1) {
      // Extract the substring before the ?
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

      // Replace the original string with the substring before the ?
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localtion = localtion.split('&page')[0]


    if (this.sortParam == undefined) {

      this.sortParam = 'id' + "," + Constant.Dsc;

    }

    this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.getAllInboundEmails();
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }


  sortData(event) {
    if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.sortParam = event.active;
      if (event.direction == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.getAllInboundEmails();
    }
  }


  addSendEmail() {
    let id = 0;
    this.router.navigate([`/emailSend/addEmailSend/${id}`])

  }

  editSendEmail(id) {
    this.router.navigate([`/emailSend/editEmailSend/${id}`])
  }

  // editGoogleCalendar(id) {
  //   const dialogRef = this.dialog.open(AddMeetingComponent, {
  //     width: '80%',
  //     maxWidth: '1200px',
  //     height: '100%',
  //     data: {
  //       "id": id,
  //       "type": 2,
  //     },
  //     position: { right: '0' },
  //     panelClass: 'slide-dialog-panel',
  //     hasBackdrop: true,
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result && result['event'] === 'add') {
  //       this.getAllSendEmails();
  //     }
  //   });
  // }

  getRelativeTime(dateString: string): string {
    const activityDate = new Date(dateString);
    const now = new Date(); // Using component initialization time for consistency
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'Just now';
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
